import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import MultiSelect from '@adv-mt/mt-form-filter-multi-select'

import {ICONS_BY_DRIVEN_WHEEL} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormDrivenWheels = ({
  initialSearch = {},
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = [0],
  withLabel,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {drivenWheels, FILTER_NAMES} = config.get('search')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const localizeOptionsLabel = option => ({
    ...option,
    icon: ICONS_BY_DRIVEN_WHEEL[option.id],
    label: i18n.t(option.label)
  })

  const localizedDrivenWheels = drivenWheels.map(localizeOptionsLabel)

  const placeholder = i18n.t('COMMON.ALL_FEM')

  const _handleOnChange = (e, {value}) => {
    const drivenWheelsIds = Array.isArray(value) ? value : [value]

    const drivenWheelsInitialSearch = initialSearch[FILTER_NAMES.DRIVEN_WHEELS]

    const hasLastFilter = drivenWheelsInitialSearch?.every(drivenWheelsId => drivenWheelsIds.includes(drivenWheelsId))

    onChange(e, {
      field: FILTER_NAMES.DRIVEN_WHEELS,
      value,
      lastFilter: hasLastFilter && TRACKING_FILTER_NAMES[FILTER_NAMES.DRIVEN_WHEELS]
    })
  }

  const label = i18n.t('COMMON.DRIVEN_WHEELS')

  const getDrivenWheelsLabelSelected = ({drivenWheelsOptions, value}) => {
    const valueSet = new Set(value)

    return drivenWheelsOptions
      .filter(item => valueSet.has(item.id))
      .map(item => item.label)
      .join(', ')
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <MultiSelect
        field={FILTER_NAMES.DRIVEN_WHEELS}
        initialSearch={initialSearch}
        label={label}
        options={localizedDrivenWheels}
        value={value}
        placeholder={placeholder}
        onChange={_handleOnChange}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL_FEM'),
          label: i18n.t('COMMON.DRIVEN_WHEELS'),
          name: FILTER_NAMES.DRIVEN_WHEELS,
          options: localizedDrivenWheels.map(({id, ...rest}) => ({...rest, id: String(id)})),
          showLabel: true,
          type
        }
      ]}
      group={`${FILTER_NAMES.DRIVEN_WHEELS}Group`}
      legend={i18n.t('COMMON.DRIVEN_WHEELS')}
      onChange={({value}) => {
        _handleOnChange(null, {value: value.filter(id => id !== allSelectionsId)})
      }}
      overlayContentRef={overlayContentRef}
      placeholder={
        value.length
          ? getDrivenWheelsLabelSelected({drivenWheelsOptions: localizedDrivenWheels, value})
          : i18n.t('COMMON.ALL_FEM')
      }
      showLegend={withLabel}
      value={{[FILTER_NAMES.DRIVEN_WHEELS]: value.length ? value.map(value => String(value)) : [allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormDrivenWheels.displayName = 'FormDrivenWheels'
FormDrivenWheels.propTypes = {
  initialSearch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default memo(FormDrivenWheels)
